
import React, { useState } from 'react'
import axios from 'axios';

import Header from './header';
import Footer from './footer';

const Booking = (props) => {
  
    const [uname, setName] = useState("");
    const [uemail, setEmail] = useState("");
    const [bdate, setbdate] = useState("");
    const [rent, setrent] = useState("300");
    const [btime, setbtime] = useState("");
    const [fdate, setfdate] = useState("");
    const [ftime, setftime] = useState("");
    const [minsdate, setminsdate] = useState("");
    const [minedate, setminedate] = useState("");
    const [maxsdate, setmaxsdate] = useState("");
    const [maxedate, setmaxedate] = useState("");
    const [error, seterror] = useState("");
    const [status, setstatus] = useState(false);
    const [msg, setMessage] = useState("");

    const formatYmd = date => date.toISOString().slice(0, 10);// Example
    var today = new Date();
    var mindate=formatYmd(today);     // 2020-05-06
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 2).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    if(mm===13) mm='01';
    var maxdate=yyyy + '-' + mm + '-' + dd;
    var mintime=("0" + today.getHours()).slice(-2);
    // + ":" + ("0" + today.getMinutes()).slice(-2);

    const onChangebDate = (e) =>setbdate(e.target.value);
    const onChangebTime = (e) => setbtime(e.target.value);
    const onChangefDate = (e) => setfdate(e.target.value);
    const onChangefTime = (e) => setftime(e.target.value);

    const onBlurbDate = (e) =>{
        if(bdate!==""&& fdate==="")
        {
            setminedate(bdate.split());
            setmaxedate(maxdate);
        }
        else if(fdate!=="" && bdate!=="")
        {
            setminedate(bdate);
            setmaxedate(maxdate);
        }
    }
    const onBlureDate = (e) =>{
        if(fdate!=="" && bdate==="")
        {
            setminsdate(mindate);
            setmaxsdate(fdate.split());
        } 
        else if(fdate!=="" && bdate!=="")
        {
            setmaxsdate(fdate);
            setminsdate(mindate);
        }
    }

    if(false)
    {
        //did this to remove warnings lol
        setEmail();
        setName();
        console.log(mintime);
    }

    const onBlurbtime = (e) =>{
        if((bdate===mindate) &&  parseInt(btime, 10)<mintime)
             {
                setstatus(false);
                seterror("Enter Valid From Time");
             }   
             else{
                setstatus(true);
                seterror("");
             }
             if(ftime!=="" &&  (parseInt(btime, 10)>parseInt(ftime, 10)))
                 {
                    setstatus(false);
                    seterror("Enter Valid From Time");
                 }
    }
    const onBlurftime = (e) =>{
        if((bdate===fdate)&&(fdate===mindate)&& parseInt(btime, 10)<mintime || (parseInt(btime, 10)>parseInt(ftime, 10)))
             {
                 setstatus(false);
                 seterror("Enter Valid From:To Time");
             }   
             else if((bdate===fdate)&&(parseInt(btime, 10)<mintime) && (fdate!==mindate))
             {
                {
                    setstatus(false);
                    seterror("Enter Valid From:To Time");
                }  
             }
             else{
                setstatus(true);
                seterror("");
             }
    }

    const onconfirm = (evt) => {
        // var cb=document.getElementById("accept");
       var bike= parseFloat(document.getElementById("bikes").value);
        var charge=parseInt(rent, 10); 
            if(bdate!==fdate)
            {
                var days=0;
                if(bdate.split('-')[1]!==fdate.split('-')[1])
                    {
                        switch(bdate.split('-')[1]){
                            case "01":
                            case "03":
                            case "05":
                            case "07":
                            case "08":
                            case "10":
                            case "12":days=31;break;
                            case "02":days=28;break;
                            default : days=30;break;
                        }
                        // switch(fdate.split('-')[1]){
                        //     case "01":
                        //     case "03":
                        //     case "05":
                        //     case "07":
                        //     case "08":
                        //     case "10":
                        //     case "12":days=days+31;break;
                        //     case "02":days=days+28;break;
                        //     default : days=days+30;break;
                        // }
                        days=days-parseInt(bdate.split('-')[2],10);
                        days=days+parseInt(fdate.split('-')[2],10);
                    }
                else days=parseInt(fdate.split('-')[2],10)-parseInt(bdate.split('-')[2],10);
                charge=charge+300+(1020*days)+(bike*(parseInt(ftime,10)+(24-parseInt(btime,10))));
                //30rs per hour cost and 720rs per day cost
            }
           else charge=charge+((bike+20)*(parseInt(ftime,10)-parseInt(btime,10)));
           charge=charge*(parseFloat(document.getElementById("cities").value));
           //50rs per hour cost
           setrent(charge);
        }

    const handleSubmit = (evt) => {
        evt.preventDefault();
        if(status===true)
        {
            console.log(`Form submitted:`);
        console.log(`NAME: ${uname}`);
        console.log(`EMAIL: ${uemail}`);
        
        const info = {
            empname: sessionStorage.getItem('name'),
            empemail: sessionStorage.getItem('email'),
            pdate: bdate,
            ptime: btime,
            ddate: fdate,
            dtime: ftime,
            brent: rent
        }
        console.log(info);
        axios.post('https://akshatngupta-bike-rental.herokuapp.com/booking/register', info)
            .then(res => {
                console.log(res.data)
                setMessage('BOOKING SUCCESSFUL')
            });

        setbdate('')
        setbtime('')
        setfdate('')
        setftime('')
        }
        else
        seterror("PLEASE INPUT VALID FROM:TO TIME!")
	}
  return (
    <div id={'in'}>
    <Header />
    <div className='main'>
        <div className='container'>
            <div className='bike-container'>
                <div className='bg-color'>
                    <div className='bike'>
                        <img src={require(`../assets/duke.png`)} alt='' />
                    </div>
                    <form className="formbox" onSubmit={handleSubmit}>
                        <div className="form2">
                            <b>
						    <h4>Make Booking</h4></b>
                            <p><b style={{ color: "brown" }}> {msg}</b></p>
							<label className="labels">Location  :</label>
							{/* <input type="text" className="form-control" value={uname} onChange={onChangeName} placeholder="Enter Name" required /> */}
							<select name="location" id="cities">
                                <option value="1.5">Delhi</option>
                                <option value="2.8">Mumbai</option>
                                <option value="1.2">Kolkata</option>
                                <option value="2.3">Banglore</option>
                                <option value="2.5">Pune</option>
                                <option value="2.0">Chennai</option>
                            </select>
                            <label className="labels">Bikes  :</label>
							{/* <input type="text" className="form-control" value={uname} onChange={onChangeName} placeholder="Enter Name" required /> */}
							<select id="bikes">
                                <option value="21">Yamaha FZ</option>
                                <option value="28">Honda CB Hornet 160</option>
                                <option value="33">TVS Apache RTR 180</option>
                                <option value="30">Yamaha Fazer 25</option>
                                <option value="15">Honda Activa 5G</option>
                                <option value="18">Honda Dio</option>
                                <option value="15">Honda Aviator</option>
                                <option value="45">Royal Enfield Himalayan</option>
                                <option value="57">Jawa Standard</option>
                                <option value="60">KTM RC 390</option>
                                <option value="92">BMW G310R</option>
                            </select>
                            <h6>Book Your Next Ride</h6>
                            <label>Date-Of-PickUp</label>
							<input type="date" className="form-control" min={minsdate} max={maxsdate} value={bdate} onChange={onChangebDate} onBlur={onBlurbDate} required/>
							<label>Date-Of-DropOff</label>
							<input type="date" className="form-control" min={minedate} max={maxedate} value={fdate} onChange={onChangefDate} onBlur={onBlureDate} required/>
                            <div>
                            <label className="align1">From:Time</label>
                            <label className="align2">To:Time</label>
                            </div>
                            <div >
                            <input type="number" className=" form-control1 " min="00" max="24" value={btime} onChange={onChangebTime} onBlur={onBlurbtime} placeholder="HH" required />
                            <input type="number" className=" form-control2 " min="00" max="24" value={ftime} onChange={onChangefTime} onBlur={onBlurftime} placeholder="HH" required/>
                            </div>
                            <div><b className="text-danger" style={{ color: "red" }}>{error}</b></div>
                            
                            <br/>
                            <label >Your Charge:</label>
                            <input type="number" className=" form-control2 " value={rent} readOnly />
                            <br/>
                            <input type="checkbox" id="accept" onChange={onconfirm} required/> I confirm to book my ride
                            <br/>
                            <button type="submit"  className="Button3" value="REGISTER">Book Ride</button>
                            <p className="forgot-password text-center">
							Already Booked <a href="./showallmybooking">My Bookings?</a>
						</p>
                        </div>
					</form>
				</div>
            </div>
        </div>
    </div>
    <Footer />
    </div>
  );
};
export default Booking;